module.exports = __webpack_public_path__ + "img/01—01—Home Network Overview > WLAN Timer > Active.2867673e.jpg";